export default __webpack_public_path__ + "static/media/search.95618c93.svg";